var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useField } from 'formik';
import React from 'react';
import { TreeBase } from './TreeBase';
export var FormikTree = function (props) {
    var _a = useField(props.name), fieldMeta = _a[1], fieldHelpers = _a[2];
    var handleOnChange = function (selectedKeys) {
        fieldHelpers.setValue(selectedKeys);
    };
    return React.createElement(TreeBase, __assign({}, props, { value: fieldMeta.value, onChange: handleOnChange }));
};
